"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryCreateUrlReadSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode }) {
        super({
            result,
            statusCode,
            componentName: 'ADD_LINK_BUTTON',
            componentSource: 'ADD_LINK_BUTTON',
            failureDescription: 'NOT_FAILURE_RESULT_EVENT'
        });
        this.action = baseSchema_1.ActionsName.TRY_CREATE_URL_READ;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
exports.default = TryCreateUrlReadSchema;
